import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CollectionProduct',
  props: {
    url: {
      type: String,
      default: ''
    },
    ratioImg: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    withLink: {
      type: String,
      default: ''
    }
  }
};